import { createAsyncThunk } from '@reduxjs/toolkit'
import { hideBoostNotification } from '../redux/reducers/Page/Boosts/pageBoost.reducer'
import { AllBoostParams } from '../types/boost'
import { getMyAdFactoryClass } from '../utils/myAdfactoryApi/getMyAdFactory.utils'
import { NewBuildRequest } from '../utils/myAdfactoryApi/swaggerApi'

export const getClientsNewBuild = createAsyncThunk(
  '/api/Signifi/NewBuild/GetClients',
  async ({ clientId }: { clientId: string }, getState) => {
    const response = await getMyAdFactoryClass(getState).getClients(clientId)
    return response
  }
)

export const getMyBoostNewBuild = createAsyncThunk(
  'newBuild/getMyBoosts',
  async (_: unknown, getState) => {
    const response = await getMyAdFactoryClass(getState).getMyBoosts()
    return response
  }
)

export const getAllBoostNewBuild = createAsyncThunk(
  'newBuild/getAllBoosts',
  async (_: unknown, getState) => {
    const response = await getMyAdFactoryClass(getState).getAllBoosts()
    return response
  }
)

export const getAdsByClient = createAsyncThunk(
  '/api/Signifi/NewBuild/GetAdsByClient',
  async (
    {
      clientId,
      contractId,
    }: { clientId: string; contractId: number | undefined },
    getState
  ) => {
    const response = await getMyAdFactoryClass(getState).getAdsByClient(
      clientId,
      contractId
    )
    return response
  }
)

export const recordBoost = createAsyncThunk(
  '/api/Signifi/NewBuild/RecordBoost',
  async (
    {
      programmes,
      clientId,
      clientName,
      nbMaxBoost,
      bsiId,
      downSellDate,
      contractId,
      contractType,
    }: NewBuildRequest,
    getState
  ) => {
    const body: NewBuildRequest = {
      programmes,
      clientId,
      clientName,
      nbMaxBoost,
      bsiId,
      downSellDate,
      contractId,
      contractType,
    }

    setTimeout(() => {
      getState.dispatch(hideBoostNotification())
    }, 5000)

    const response = await getMyAdFactoryClass(getState).recordBoost(body)
    return response
  }
)

export const getFilterMyBoostNewBuild = createAsyncThunk(
  'newBuild/getFilterMyBoosts',
  async (
    {
      page,
      itemsPerPage,
      order = 'CreatedDate',
      orderDirection = 'desc',
    }: AllBoostParams,
    getState
  ) => {
    const response = await getMyAdFactoryClass(getState).getMyFilterBoosts(
      page,
      itemsPerPage,
      order,
      orderDirection
    )
    return response
  }
)

export const getFilterAllBoostNewBuild = createAsyncThunk(
  'newBuild/getFilterAllBoosts',
  async (
    {
      page,
      itemsPerPage,
      order = 'CreatedDate',
      orderDirection = 'desc',
    }: AllBoostParams,
    getState
  ) => {
    const response = await getMyAdFactoryClass(getState).getAllFilterBoosts(
      page,
      itemsPerPage,
      order,
      orderDirection
    )
    return response
  }
)
